module.exports = __webpack_public_path__ + "img/social-media-display-ford.7b515a02.png";